import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useQuery, gql } from "@apollo/client";
import { useState } from "react";

const GET_HOME = gql`
  query {
    home {
      data {
        attributes {
          vision
          mission
          objectives
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  section: {
    background: "#fff",
    padding: theme.spacing(8, 0),
  },
  sectionTitle: {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 800,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#062a51",
    marginBottom: theme.spacing(1),
  },
  underline: {
    width: 48,
    height: 4,
    background: "#26a69a",
    borderRadius: 2,
    margin: "0 auto",
    marginBottom: theme.spacing(6),
  },
  grid: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 24,
    maxWidth: 960,
    margin: "0 auto",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "32px 24px",
    borderTop: "4px solid #26a69a",
    boxShadow: "0 4px 20px rgba(6,42,81,0.07)",
    display: "flex",
    flexDirection: "column" as const,
    transition: "transform 0.3s, box-shadow 0.3s",
    cursor: "default",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 12px 30px rgba(38,166,154,0.14)",
    },
  },
  cardTitle: {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 800,
    fontSize: "1.5rem",
    letterSpacing: "2px",
    textTransform: "uppercase" as const,
    color: "#062a51",
    marginBottom: 10,
    textAlign: "center" as const,
  },
  cardDivider: {
    width: 28,
    height: 3,
    background: "#26a69a",
    borderRadius: 2,
    margin: "0 auto 16px",
  },
  visionText: {
    fontStyle: "italic",
    color: "#000000",
    lineHeight: 1.75,
    fontSize: "0.92rem",
    textAlign: "center" as const,
  },
  missionText: {
    color: "#000000",
    lineHeight: 1.75,
    fontSize: "0.92rem",
    textAlign: "center" as const,
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200,
  },
}));

export default function Primarymv(_props: any) {
  const classes = useStyles();
  const [apiData, setApiData] = useState({
    vision: "",
    mission: "",
    objectives: "",
  });

  const { loading } = useQuery(GET_HOME, {
    onCompleted(data) {
      setApiData({
        vision: data.home.data.attributes.vision,
        mission: data.home.data.attributes.mission,
        objectives: data.home.data.attributes.objectives,
      });
    },
  });

  return (
    <div className={classes.section}>
      <Container maxWidth="lg">
        <Typography variant="h4" className={classes.sectionTitle}>
          Our Purpose
        </Typography>
        <div className={classes.underline} />

        {loading ? (
          <div className={classes.loadingBox}>
            <CircularProgress style={{ color: "#26a69a" }} />
          </div>
        ) : (
          <div className={classes.grid}>

            {/* Vision */}
            <div className={classes.card}>
              <div className={classes.cardTitle}>Vision</div>
              <div className={classes.cardDivider} />
              <p className={classes.visionText}>{apiData.vision}</p>
            </div>

            {/* Mission */}
            <div className={classes.card}>
              <div className={classes.cardTitle}>Mission</div>
              <div className={classes.cardDivider} />
              <p className={classes.missionText}>{apiData.mission}</p>
            </div>

            {/* Objectives */}
            <div className={classes.card}>
              <div className={classes.cardTitle}>Objectives</div>
              <div className={classes.cardDivider} />
              <div
                className="ql-container ql-snow"
                style={{ fontFamily: "Karla, sans-serif" }}
              >
                <div
                  className="ql-editor"
                  style={{ fontSize: "0.88rem", color: "#000000", lineHeight: 1.8, padding: 0, textAlign: "left" }}
                  dangerouslySetInnerHTML={{ __html: apiData.objectives }}
                />
              </div>
            </div>

          </div>
        )}
      </Container>
    </div>
  );
}
